// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-reminder-container {
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
    margin-bottom: 15px;
}

.preview-reminder-container {
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
    margin-bottom: 15px;
}

.reminder-title {
    font-size: 14px;
    color: #6c757d;
    margin-bottom: 8px;
}

.reminder-example-container {
    background-color: #e3f2fd;
    padding: 10px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.reminder-preview-container {
    background-color: #e7f6e7;
    padding: 10px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.reminder-text {
    color: #555;
}

.number-highlight {
    background-color: #1976d2;
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: bold;
}

.tag-style {
    background-color: #bbdefb;
    color: #1976d2;
    padding: 2px 8px;
    border-radius: 4px;
}

.tag-style-preview {
    background-color: #c8e6c9;
    color: #2e7d32;
    padding: 2px 8px;
    border-radius: 4px;
}

.number-highlight-preview {
    background-color: #2e7d32;
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: bold;
}

.submit-button {
    margin-top: 15px;
    display: flex;
    justify-content: center;
}

.reminder-form-container {
    display: flex;
    align-items: center;
    justify-content: start;
    flex-wrap: wrap;
    gap: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/App/components/Loan/admin/LoanReminders/NewReminder.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,WAAW;AACf","sourcesContent":[".example-reminder-container {\n    padding: 15px;\n    background-color: #f8f9fa;\n    border-radius: 8px;\n    margin-bottom: 15px;\n}\n\n.preview-reminder-container {\n    padding: 15px;\n    background-color: #f8f9fa;\n    border-radius: 8px;\n    margin-bottom: 15px;\n}\n\n.reminder-title {\n    font-size: 14px;\n    color: #6c757d;\n    margin-bottom: 8px;\n}\n\n.reminder-example-container {\n    background-color: #e3f2fd;\n    padding: 10px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.reminder-preview-container {\n    background-color: #e7f6e7;\n    padding: 10px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.reminder-text {\n    color: #555;\n}\n\n.number-highlight {\n    background-color: #1976d2;\n    color: white;\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-weight: bold;\n}\n\n.tag-style {\n    background-color: #bbdefb;\n    color: #1976d2;\n    padding: 2px 8px;\n    border-radius: 4px;\n}\n\n.tag-style-preview {\n    background-color: #c8e6c9;\n    color: #2e7d32;\n    padding: 2px 8px;\n    border-radius: 4px;\n}\n\n.number-highlight-preview {\n    background-color: #2e7d32;\n    color: white;\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-weight: bold;\n}\n\n.submit-button {\n    margin-top: 15px;\n    display: flex;\n    justify-content: center;\n}\n\n.reminder-form-container {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
